import React, {useContext, useState, useEffect, useRef} from 'react';

import {Stack, Typography, Button, Box, TextField} from '@mui/material';

import {Link, useNavigate, useOutletContext} from 'react-router-dom';

import {MultipleChoiceButtonGroup} from '../../../components/buttons/multipleChoiceButtonGroup';

import mainLogo from '../../../images/black_letters_with_blue_shadow.svg';

import {Swiper, SwiperSlide} from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Custom CSS
import './guestlogin.css';

// import required modules
import {EffectFade, Navigation, Pagination} from 'swiper/modules';
import AuthContext from '../../../context/AuthContext';

export const GuestLogin = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const swiperRef = useRef(null);
  const [isLastSlide, setIsLastSlide] = useState(false);

  const handleNextClick = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }

    if (isLastSlide) {
      authContext.loginGuestUser().then(() => {
        navigate('/guest-demographics');
      });
    }
  };

  const handleSkipClick = () => {
    if (swiperRef.current) {
      const swiperInstance = swiperRef.current.swiper;
      swiperInstance.slideTo(swiperInstance.slides.length - 1);
    }
  };

  const handleSlideChange = () => {
    if (swiperRef.current) {
      const swiperInstance = swiperRef.current.swiper;
      setIsLastSlide(swiperInstance.activeIndex === swiperInstance.slides.length - 1);
    }
  };

  const [userData, setUserData] = useState({
    isPregnant: true,
  });

  const updateUserData = (key, value) => {
    setUserData(prev => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <Box className="guest-login-wrapper">
      {/* Login Card */}
      <Stack className="login-card">
        <Box className="card-header" textAlign="center">
          <img src={mainLogo} height={80} className="aimd-logo" />
        </Box>

        {/* Card Body */}
        <Box className="card-body">
          <Swiper
            ref={swiperRef}
            spaceBetween={false}
            effect={'fade'}
            navigation={true}
            pagination={{clickable: true}}
            modules={[EffectFade, Navigation, Pagination]}
            className="loginSwiper"
            onSlideChange={handleSlideChange}
          >
            {/* Slide */}
            <SwiperSlide>
              {/* AI-Intro */}
              <Stack className="facescan bg-light" minHeight="540px">
                <Box marginTop="2.33rem" className="img-box">
                  <img src="/images/bp.png" className="responsive-img" height="330px" alt="" />
                </Box>

                <Stack className="card-info" textAlign="center" marginTop="1rem">
                  <Typography variant="h4" component="h4">
                    Welcome to AI-MD!
                  </Typography>
                  <Typography variant="p" component="p" className="info-txt" marginTop={1}>
                    Convert health data collected using the hardware on your phone to actionable health scores and
                    recommendations.
                  </Typography>
                </Stack>
              </Stack>
              {/* AI-Intro / */}
            </SwiperSlide>
            {/* Slide / */}

            {/* Slide */}
            <SwiperSlide>
              {/* Questionnaire */}
              <Stack className="bg-light questionnaire" minHeight="540px">
                <Box className="m-choice-btns" marginLeft={1}>
                  <MultipleChoiceButtonGroup
                    title="Are you pregnant?"
                    choices={[
                      {
                        value: true,
                        text: 'Yes',
                      },
                      {
                        value: false,
                        text: 'No',
                      },
                    ]}
                    selected={userData.isPregnant}
                    setSelected={newVal => {
                      updateUserData('isPregnant', newVal);
                    }}
                  />
                </Box>

                <Box className="heart-checker" marginRight={1} marginTop={2}>
                  <Box className="m-choice-btns" maxWidth="183px">
                    <MultipleChoiceButtonGroup
                      title="Have you had a heart attack before?"
                      choices={[
                        {
                          value: true,
                          text: 'Yes',
                        },
                        {
                          value: false,
                          text: 'No',
                        },
                      ]}
                      selected={userData.isPregnant}
                      setSelected={newVal => {
                        updateUserData('isPregnant', newVal);
                      }}
                    />
                  </Box>
                </Box>

                <Box className="symptoms" marginTop={4} marginRight={2} marginLeft={1}>
                  <Box className="m-choice-btns">
                    <MultipleChoiceButtonGroup
                      title="Are you experiencing any health symptoms?"
                      choices={[
                        {
                          value: true,
                          text: 'I have symptoms.',
                        },
                        {
                          value: false,
                          text: 'I am healthy.',
                        },
                      ]}
                      selected={userData.isPregnant}
                      setSelected={newVal => {
                        updateUserData('isPregnant', newVal);
                      }}
                    />
                  </Box>
                </Box>

                <Stack className="card-info" textAlign="center" marginTop={8}>
                  <Typography variant="h4" component="h4">
                    Tell Us About You
                  </Typography>
                  <Typography variant="p" component="p" className="info-txt" marginTop={1}>
                    Give us a quick overview of your age, gender, and medical history.
                  </Typography>
                </Stack>
              </Stack>
              {/* Questionnaire / */}
            </SwiperSlide>
            {/* Slide / */}

            {/* Slide */}
            <SwiperSlide>
              {/* Face Scan */}
              <Stack className="bg-light face-scan" minHeight="540px">
                <Box display="flex" flexDirection="row" justifyContent="end">
                  <Stack display="flex" alignItems="end" maxWidth="262px" textAlign="end" marginRight={1}>
                    <Typography variant="p" component="p" marginTop={1} marginBottom={1} textAlign="end">
                      Next we will scan your face to assess your vital signs.
                    </Typography>
                    <Button className="scan-btn">Start Face Scan</Button>
                  </Stack>
                </Box>

                <Box marginTop={2} className="img-box">
                  <img src="/images/scan.png" alt="face-scan" />
                </Box>

                <Stack className="card-info" textAlign="center" marginTop={6}>
                  <Typography variant="h4" component="h4">
                    Face Scan
                  </Typography>
                  <Typography variant="p" component="p" className="info-txt" marginTop={1}>
                    Take a 30-second video of your face to measure metrics such as blood pressure and heart rate.
                  </Typography>
                </Stack>
              </Stack>
              {/* Face Scan / */}
            </SwiperSlide>
            {/* Slide / */}

            {/* Slide */}
            <SwiperSlide>
              {/* Symptoms */}
              <Stack className="facescan bg-light" minHeight="540px">
                <Box marginLeft={1} marginRight={1}>
                  <Typography variant="p" component="p" className="info-txt">
                    Can you tell us more?
                  </Typography>
                  <Box className="shadow-card" marginTop={1}>
                    <Typography variant="p" component="p" fontSize="15px">
                      I have been feeling extra tired lately and I have developed a dry cough. I was recently on a plane
                      traveling home from a work conference and it seemed to start then.
                    </Typography>
                    <Stack display="flex" flexDirection="row" alignItems="center" marginTop={1} className="img-box">
                      <img src="/others/lgreencircle.svg" width="15" height="15" alt="" />
                      <Typography variant="small" component="small" fontSize="13px" color="#A1A0A0" paddingLeft="5px">
                        Adequate symptom details detected.
                      </Typography>
                    </Stack>
                  </Box>
                </Box>

                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="end"
                  textAlign="end"
                  marginTop={3}
                  marginRight={1}
                >
                  <Typography variant="p" component="p" textAlign="end" className="info-txt">
                    So you’re having respiratory symptoms.
                  </Typography>
                  <Typography variant="p" component="p" maxWidth="270px" marginTop="2px">
                    When you’re ready, press the record button and cough for 3 seconds.
                  </Typography>

                  <Stack display="flex" className="img-box" flexDirection="row" alignItems="center" marginTop={2}>
                    <img src="/images/wave.png" className="wave-img" alt="" />
                    <img src="/images/recoding.png" width="60px" height="70px" alt="" />
                  </Stack>
                </Box>

                <Stack className="card-info" textAlign="center">
                  <Typography variant="h4" component="h4">
                    Input Your Symptoms
                  </Typography>
                  <Typography variant="p" component="p" className="info-txt" marginTop={1}>
                    Describe any symptoms you’re experiencing including photos, audio, and videos related to your
                    symptoms.
                  </Typography>
                </Stack>
              </Stack>
              {/* Symptoms / */}
            </SwiperSlide>
            {/* Slide / */}

            {/* Slide */}
            <SwiperSlide>
              {/* Analysis Result */}
              <Stack className="facescan bg-light" minHeight="540px">
                <Box className="img-box">
                  <img src="/images/analysis1.png" className="responsive-img" height="480px" alt="" />
                </Box>

                <Stack className="card-info" textAlign="center" marginTop="-7rem">
                  <Typography variant="h4" component="h4">
                    Get Health Results
                  </Typography>
                  <Typography variant="p" component="p" className="info-txt" marginTop={1}>
                    Get instant access your health insights, giving you clear and actionable health information to make
                    informed decisions.
                  </Typography>
                </Stack>
              </Stack>
              {/* Analysis Result / */}
            </SwiperSlide>
            {/* Slide / */}

            {/* Slide */}
            <SwiperSlide>
              {/* Symptoms */}
              <Stack className="find-solution bg-light" minHeight="540px">
                <Box className="img-box">
                  <img src="/images/analysis.png" height="480px" className="responsive-img" alt="" />
                </Box>

                <Stack className="card-info" textAlign="center" marginTop="-6rem">
                  <Typography variant="h4" component="h4">
                    Find Solutions
                  </Typography>
                  <Typography variant="p" component="p" className="info-txt">
                    Learn about products that have helped people with a similar health state within your demographic and
                    providers near you.
                  </Typography>
                </Stack>
              </Stack>
              {/* Symptoms / */}
            </SwiperSlide>
            {/* Slide / */}
          </Swiper>
        </Box>
        {/* Card Body / */}

        {/* Card Footer */}
        {!isLastSlide && (
          <Stack display="flex" flexDirection="column" justifyContent="center" alignItems="center" marginTop={1}>
            <Button className="next-btn" id="nextBtn" onClick={handleNextClick}>
              Next
            </Button>
            <Button className="skip-btn" id="skipBtn" onClick={handleSkipClick}>
              Skip
            </Button>
          </Stack>
        )}

        {isLastSlide && (
          <Stack>
            <Stack
              display="flex"
              flexDirection="row"
              // justifyContent="space-between"
              justifyContent="center"
              alignItems="center"
              marginTop={1}
              className="login-footer"
            >
              <Link to="/user-login" className="login-btn">
                Log In
              </Link>
              {/* <Button className="next-btn guest-btn" id="nextBtn" onClick={handleNextClick}>
                Continue as guest
              </Button> */}
            </Stack>

            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              className="register-link"
            >
              <Typography variant="p" component="p" className="info-txt" marginRight={1}>
                Or, if you’re new,
              </Typography>
              <Link to="/register" className="info-txt">
                create an account
              </Link>
            </Box>
          </Stack>
        )}

        {/* Card Footer / */}
      </Stack>
      {/* Login Card / */}
    </Box>
  );
};
